import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { GaugeCircle, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) {
      setErr("Passwords do not match");
      return;
    }
    if (password.length < 8) {
      setErr("Password must be at least 8 characters");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setOk(true);
      setTimeout(() => nav("/login"), 1800);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col justify-center items-center p-5" data-testid="reset-page">
      <Link to="/" className="flex items-center gap-2 mb-8">
        <div className="w-9 h-9 rounded-lg bg-navy-900 flex items-center justify-center">
          <GaugeCircle className="w-5 h-5 text-orange-500" />
        </div>
        <span className="font-bold text-lg">EntryBook</span>
      </Link>
      <div className="w-full max-w-md bg-white rounded-2xl shadow-card border border-navy-100 p-8">
        <h1 className="text-2xl font-semibold mb-5">Choose a new password</h1>
        {ok ? (
          <div className="rounded-md bg-success/10 border border-success/30 text-success px-3 py-3 text-sm flex items-center gap-2" data-testid="reset-ok">
            <CheckCircle2 className="w-4 h-4" /> Password updated. Redirecting to login…
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="eb-label">New password</label>
              <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="eb-input" data-testid="reset-password-input" />
            </div>
            <div>
              <label className="eb-label">Confirm password</label>
              <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="eb-input" data-testid="reset-confirm-input" />
            </div>
            {err && <div className="rounded-md bg-danger/10 border border-danger/30 text-danger text-sm px-3 py-2" data-testid="reset-error">{err}</div>}
            <button type="submit" disabled={loading || !token} className="btn-accent w-full" data-testid="reset-submit-btn">
              {loading ? "Saving…" : "Update password"}
            </button>
            {!token && <p className="text-xs text-danger">Missing token. Request a new reset email.</p>}
          </form>
        )}
      </div>
    </div>
  );
}
